import { cn } from '@/shared/lib';

export interface MonogramProps {
  /** Название записи — берётся первая буква. */
  title: string;
  className?: string;
}

/** Монограмма карточки (README §5: 34, radius 18, фон gold-wash, wine-ink 18 600). */
export function Monogram({ title, className }: MonogramProps) {
  const letter = title.trim().charAt(0).toUpperCase();
  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex size-34 shrink-0 items-center justify-center rounded-18 bg-gold-wash text-[18px] font-semibold text-wine-ink',
        className,
      )}
    >
      {letter}
    </span>
  );
}
